import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { useClickAway } from 'use-click-away'
import './ProductDropDownStyle.scss'

const ProductDropDown = ({ products }) => {
  const [open, setOpen] = useState(false)
  const ref = React.useRef(null)
  useClickAway(ref, () => {
    setOpen(false)
  })

  return (
    <div className="products" ref={ref}>
      <button onClick={() => setOpen(!open)} className="no-style-btn" type="button">
        <p className="product">Produit.s</p>
      </button>
      {open && (
        <div className="product-dropdown">
          {products.map((product) => (
            <p
              key={product.materialByIdMaterial.id}
              className={
                product.materialByIdMaterial.productCategoryByIdProductCategory.family === 'RUBBLE'
                  ? 'blue'
                  : ''
              }
            >
              {product.materialByIdMaterial.description}
            </p>
          ))}
        </div>
      )}
    </div>
  )
}

ProductDropDown.propTypes = {
  products: PropTypes.arrayOf(
    PropTypes.shape({
      materialByIdMaterial: PropTypes.shape({
        id: PropTypes.string,
        description: PropTypes.string,
      }).isRequired,
    })
  ).isRequired,
}

export default ProductDropDown
